import { useUserDetailsQuery } from '../hooks/useUser';
import { cn } from '../lib/utils';
import ActivityIndicator from './ActivityIndicator';

const ProPageRenderer = ({ children, className }) => {
  const userQuery = useUserDetailsQuery();

  if (userQuery.isLoading) {
    return (
      <div className={cn('flex-grow h-full pt-24 flex items-center justify-center', className)}>
        <div className='flex justify-center items-center h-full max-w-3xl mx-auto'>
          <ActivityIndicator />
        </div>
      </div>
    );
  }

  return <div className={cn('flex-grow h-full', className)}>{children}</div>;
};

export default ProPageRenderer;
